
import borders from "../../base/borders";
import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";
const { borderWidth } = borders;
const { light } = colors;

const tableBody = {

};

export default tableBody;
